export default "__VITE_ASSET__09b361be__"